//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet } from '../../axios/axios.js'
import { convertRequestFromServer, REQUEST_PRIORITIES } from '../../forms/Request/Request.js'
import { requestActionsCancelAssignment } from '../../forms/Request/RequestActionsCancelAssignment.js'
import { convertRequestPriority } from '../../components/helpers.js'

export default {
  mixins: [requestActionsCancelAssignment],
  props: {
    requestId: {
      type: Number,
      default: null
    },
    requestData: {
      type: Object,
      default: null
    },
    editing: {
      type: Boolean,
      default: false
    },
    disabledInEditing: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    length: {
      type: Number,
      default: null
    },
    reports: {
      type: Array,
      default () {
        return []
      }
    },
    brigadeName: {
      type: String,
      default: ''
    },
    brigadeEndWorkTime: {
      type: Number,
      default: 0
    },
    requestStartTime: {
      type: Number,
      default: 0
    },
    riStateName: {
      type: String,
      default: null
    },
    riBrigades: {
      type: Array,
      default () {
        return []
      }
    },
    travelTime: {
      type: Number,
      default: null
    },
    travelDistanse: {
      type: Number,
      default: null
    },
    distanse: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      headerOpened: false,
      opened: false,
      loading: false,
      request: null,
      currentRequestTypes: [],
      requestPriorities: REQUEST_PRIORITIES,
      modalImagesSliderOpened: false,
      modalImagesSliderParams: {
        closeOnMask: false,
        fullScreen: true,
        middle: false,
        hasMask: false,
        hasDivider: true
      }
    }
  },
  computed: {
    ...mapGetters({
      requestTypes: 'getRequestTypes',
      requestSources: 'getRequestSources',
      taskStatesColors: 'getTaskStatesColors',
      requestTypesColors: 'getRequestTypesColors',
      reportStateColors: 'getReportStateColors',
      reportStateTextColors: 'getReportStateTextColors'
    }),
    requestConfig: function () {
      return this.requestData || this.requestId || null
    },
    requestTypeColor: function () {
      return (this.request && this.request.requestTypeKey && this.requestTypesColors && this.requestTypesColors[this.request.requestTypeKey]) || 'white'
    },
    showReportStateWarning: function () {
      return !!(this.request && this.request.reportState === 'PR11')
    },
    reportStateColor: function () {
      const stateId = this.request.reportState
      return this.reportStateColors && stateId && this.reportStateColors[stateId] || null
    },
    reportStateTextColor: function () {
      const stateId = this.request.reportState
      return this.reportStateTextColors && stateId && this.reportStateTextColors[stateId] || null
    },
    reportStateLabelStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold; margin-left: 4px; padding: 0 4px;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    },
    reportStateBadgeStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    }
  },
  watch: {
    requestConfig: {
      handler: function (value) {
        if (value && typeof value === 'object') {
          this.request = value
          this.prepareCurrentRequestTypes()
        } else if (value && typeof value === 'number') {
          this.loadRequest(value)
          this.prepareCurrentRequestTypes()
        } else {
          this.request = null
        }
      },
      immediate: true
    }
  },
  methods: {
    formatTravelDistanse: function (travelDistanseInMeters) {
      if (travelDistanseInMeters > 1000) {
        let formattedDistance = Math.floor(travelDistanseInMeters / 1000)
        if (Math.round(Math.round(travelDistanseInMeters % 1000) !== 0)) {
          let distanceTail = Math.round(Math.round(travelDistanseInMeters % 1000))
          if (distanceTail > 100) {
            while (distanceTail > 9) {
              distanceTail = distanceTail / 10
            }
            formattedDistance += '.' + Math.round(distanceTail) + 'км'
            return formattedDistance
          } else {
            return formattedDistance + 'км'
          }
        } else {
          return formattedDistance + 'км'
        }
      } else {
        return Math.round(travelDistanseInMeters) + 'м'
      }
    },
    formatTravelTime: function (travelTime) {
      if (Math.floor(Math.round(travelTime / 60000) / 60) > 0) {
        let formattedTime = Math.floor(Math.round(travelTime / 60000) / 60) + 'ч '
        if (Math.round(Math.round(travelTime / 60000) % 60) !== 0) {
          formattedTime += Math.round(Math.round(travelTime / 60000) % 60) + 'мин'
        }

        return formattedTime
      } else {
        if (Math.round(travelTime / 60000) === 0) {
          return '1мин'
        } else {
          return Math.round(travelTime / 60000) + 'мин'
        }
      }
    },
    openServiceObjectCard: function (event) {
      this.$d_showObjectCard(this.request.serviceObjectId, this.request.serviceObjectType, event.ctrlKey)
    },
    getPriorityColor: function (value) {
      const formattedValue = convertRequestPriority(value)

      if (formattedValue === 'Низкий') {
        return 'light-blue-1'
      } else if (formattedValue === 'Средний') {
        return 'warning'
      } else {
        return 'negative'
      }
    },
    getPriorityTooltipText: function (value) {
      const formattedValue = convertRequestPriority(value)

      if (formattedValue === 'Низкий') {
        return 'Заявка с низким приоритетом'
      } else if (formattedValue === 'Средний') {
        return 'Заявка со средним приоритетом'
      } else if (formattedValue === 'Высокий') {
        return 'Заявка с высоким приоритетом'
      } else if (formattedValue === 'Срочно') {
        return 'Заявка со срочным приоритетом'
      } else if (formattedValue === 'Критический') {
        return 'Заявка с критическим приоритетом'
      }
    },
    getServiceObjectIcon: function (serviceObjectType) {
      if (serviceObjectType === 'trafficLight') {
        return 'mdi-traffic-light'
      } else if (serviceObjectType === 'transportDetector') {
        return 'mdi-contactless-payment'
      } else if (serviceObjectType === 'TOI') {
        return 'mdi-monitor-dashboard'
      } else if (serviceObjectType === 'cameraFVF') {
        return 'mdi-camera-wireless'
      } else if (serviceObjectType === 'cameraTV') {
        return 'mdi-video-wireless'
      } else {
        return 'mdi-traffic-cone'
      }
    },
    getTaskStateColor: function () {
      if (this.request.bpStateId && this.taskStatesColors && this.taskStatesColors[this.request.bpStateId]) {
        return this.taskStatesColors[this.request.bpStateId]
      } else {
        return 'white'
      }
    },
    openAddressInYandexMaps: function () {
      const url = this.$d.getYandexMapsLocationUrl(this.request.location)
      window.open(url)
    },
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    },
    loadRequest: function (requestId) {
      this.loading = true
      return axiosGet({
        url: '/service/delta/request/getRequest?id=' + requestId,
        onSuccess: (response) => {
          const user = this.$store.getters.getUser
          this.request = convertRequestFromServer(response.data.result, user)
        },
        onFailure: 'Ошибка получения информации по заявке',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    prepareCurrentRequestTypes: function () {
      if (this.request && this.request.serviceObjectType && this.requestTypes) {
        this.currentRequestTypes = []
        this.requestTypes.forEach(requestType => {
          if (requestType.serviceObjectType && requestType.serviceObjectType.find(serviceObjectType => serviceObjectType.key === this.request.serviceObjectType)) {
            this.currentRequestTypes.push(requestType)
          }
        })
      } else {
        this.currentRequestTypes = this.requestTypes
      }
    },
    getLastRework: function () {
      if (this.reports && this.reports.length) {
        const reports = this.reports
        if (reports.length && reports[reports.length - 1].reworks) {
          const reworks = reports[reports.length - 1].reworks
          if (reworks.length) {
            return reworks[reworks.length - 1]
          }
        }
      }
      return null
    },
    getLastReworkReason: function () {
      const lastRework = this.getLastRework()
      return (lastRework && lastRework.reason) || null
    },
    getLastReworkDeferralTime: function () {
      const lastRework = this.getLastRework()
      return (lastRework && lastRework.deferralTime) || null
    },
    openIpAddress: function () {
      window.open('http://' + this.request.serviceObject.deviceIp)
    },

    onDelete: function () {
      this.askCancelAssignment(props => {
        this.$emit('delete', this.index, props.cancelAppointmentAction)
      })
    }
  }
}

